import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import Link from 'components/common/Link';
import TextField from 'components/fields/TextField';
import FormError from 'components/common/FormError';

import { accountSignUpCodeCheck } from 'redux/modules/account';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

const styles = theme => ({
  grid: {
    marginTop: 15,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

function onSubmit(values, dispatch) {
  return new Promise((resolve, reject) => {
    dispatch(accountSignUpCodeCheck({
      values: {
        Email: values.Email,
        Code: values.Code,
      },
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      throw new SubmissionError({
        _error: err.error,
      });
    });
}

const SignUpPhoneConfirmForm = ({ className, handleSubmit, error, onCodeSend, classes }) => (
  <form
    className={className}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    {error &&
      <Grid
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Code"
          name="Code"
          label="Authentication Code"
          placeholder="Enter Code"
          component={TextField}
          validate={[validate.required]}
          normalize={normalize.removeSpaces}
          size="lg"
          type="text"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      container
      alignItems="center"
      justify="flex-end"
      spacing={24}
    >
      <Grid item>
        <Link
          size="md"
          onClick={onCodeSend}
        >
          Resend Code
        </Link>
      </Grid>
    </Grid>
  </form>
);

SignUpPhoneConfirmForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  onCodeSend: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

SignUpPhoneConfirmForm.defaultProps = {
  error: null,
  className: '',
};

export default reduxForm({
  onSubmit,
})(withStyles(styles)(SignUpPhoneConfirmForm));



// WEBPACK FOOTER //
// ./src/components/account/SignUpPhoneConfirm/SignUpPhoneConfirmForm.js